import React, { useEffect, useMemo, useState } from "react";
import { Table, Tag, Dropdown, Button } from "antd";
import {
  IconPlus,
  IconArrowRight,
  IconStarFilled,
  IconStar,
} from "@tabler/icons-react";
import CustomBtn from "../../components/btn/CustomBtn";
import PageHeader from "../../components/header/PageHeader";
import { useToast } from "../../components/toast";
import api from "../../api";
import { formatCurrency } from "../../utils/helpers";
import ConfirmModal from "../../components/modal/ConfirmModal";
import CreateBundles from "./components/CreateBundles";

export default function Bundle() {
  // --- state ---
  const [visible, setVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [selectedData, setSelectedData] = useState({});
  const [featureModal, setFeatureModal] = useState(false);
  const [toggleId, setToggleId] = useState(null);

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [featureLoading, setFeatureLoading] = useState(false);
  const toast = useToast();

  const openEdit = (row) => {
    setEditingId(row.id);
    setSelectedData(row);
    setShowModal(true);
  };

  // ---- fetch list ----
  const fetchList = async () => {
    setLoading(true);
    const res = await api.get_bundles();
    // console.log("res bundles --->", res);
    if (res.status === 200) {
      setList(res?.data?.data || []);
    } else {
      toast(res?.data?.message || "Алдаа гарлаа.", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchList();
  }, []);

  // const handleDelete = async (id) => {
  //   const res = await api.delete_bundle(id);

  //   if (res.status === 200 && res.data?.success) {
  //     toast(res.data.message, res.data.deleted ? "success" : "warning");
  //     setEditingId(null);
  //     fetchList();
  //   } else {
  //     toast(res.data?.message || "Алдаа гарлаа", "error");
  //   }
  // };

  const handleDelete = async (id) => {
    const res = await api.delete_bundle(id);
    if (res.status === 200 && res.data?.success) {
      toast(res.data.message, "success");
      setEditingId(null);
      fetchList();
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
  };

  const handleFeature = async (id) => {
    setFeatureLoading(true);
    const res = await api.toggle_feature(id);
    if (res.status === 200) {
      fetchList();
      toast("Амжилттай", "success");
    } else {
      toast(res?.data?.message || "Алдаа гарлаа", "error");
    }
    setToggleId(null);
    setFeatureLoading(false);
  };

  // ====== table ======
  const columns = useMemo(
    () => [
      {
        title: "",
        dataIndex: "is_featured",
        key: "is_featured",
        width: 50,
        render: (_, row) => (
          <Button
            type="link"
            onClick={() => {
              setToggleId(row.id);
              setFeatureModal(true);
            }}
            disabled={featureLoading}
          >
            {row.is_featured ? (
              <IconStarFilled size={18} color="#faad14" />
            ) : (
              <IconStar size={18} color="#888" />
            )}
          </Button>
        ),
      },
      {
        title: "Program",
        dataIndex: "program",
        key: "program",
        width: 140,
        render: (val) => {
          return <Tag color={val === "YOGA" ? "blue" : "cyan"}>{val}</Tag>;
        },
      },
      {
        title: "Багцын нэр",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Оролт",
        dataIndex: "credits",
        key: "credits",
        width: 140,
        render: (val, row) => (row.kind === "COUNT" ? (val ?? "-") : "-"),
      },
      {
        title: "Хүчинтэй хоног",
        dataIndex: "valid_days",
        key: "valid_days",
        width: 140,
      },
      {
        title: "Цагийн хязгаар",
        dataIndex: "restrict_time",
        key: "restrict_time",
        width: 140,
        render: (val) => val || "-",
      },
      {
        title: "Үнэ (₮)",
        dataIndex: "price",
        key: "price",
        width: 200,
        render: (val) => formatCurrency(val) ?? "-",
      },
      // { title: "Дэлгэрэнгүй", dataIndex: "description", key: "description" },
      {
        title: "Зураг",
        dataIndex: "cover_image",
        key: "cover_image",
        width: 140,
        render: (url) =>
          url ? (
            <img
              alt="cover"
              src={url}
              style={{
                width: 56,
                height: 36,
                objectFit: "cover",
                borderRadius: 4,
              }}
            />
          ) : (
            <span style={{ color: "#999" }}>–</span>
          ),
      },
      {
        title: "Үйлдэл",
        key: "actions",
        width: 150,
        render: (_, record) => {
          const items = (record) => [
            {
              key: "edit",
              label: (
                <span style={{ color: "black", fontSize: "13px" }}>Засах</span>
              ),
            },
            {
              key: "delete",
              label: (
                <span style={{ color: "red", fontSize: "13px" }}>Устгах</span>
              ),
            },
          ];

          return (
            <Dropdown
              menu={{
                items: items(record),
                onClick: ({ key }) => {
                  if (key === "delete") {
                    // console.log("Устгах:", record);
                    setEditingId(record.id);
                    setVisible(true);
                  } else if (key === "edit") {
                    // console.log("detail", record);
                    openEdit(record);
                    // setSelectedRecord(record);
                    // setShowDrawer(true);
                  }
                },
              }}
              trigger={["click"]}
            >
              <Button variant="filled" color="default" style={{ fontSize: 12 }}>
                Үйлдэл
                <IconArrowRight size={12} />
              </Button>
            </Dropdown>
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <PageHeader
        title={"Багц"}
        right={
          <CustomBtn
            title="Багц нэмэх"
            icon={<IconPlus size={18} />}
            // onClick={openCreate}
            onClick={() => setShowModal(true)}
          />
        }
      />

      <Table
        rowKey="id"
        columns={columns}
        dataSource={list}
        loading={loading}
        pagination={{ pageSize: 10, showSizeChanger: false }}
      />

      <CreateBundles
        showModal={showModal}
        setShowModal={setShowModal}
        trigger={() => fetchList()}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
      />

      <ConfirmModal
        variant="error"
        title="Итгэлтэй байна уу?"
        // description={
        //   <>
        //     Уг багцыг устгах гэж байна. Хэрэв тухайн багц дээр{" "}
        //     <span style={{ fontWeight: 600, color: "#000" }}>
        //       төлбөр хийгдсэн
        //     </span>{" "}
        //     бол устахгүй, зөвхөн идэвхгүй болно.
        //   </>
        // }
        description={
          <>
            Уг багцыг устгах гэж байна. Төлбөрийн түүх хадгалагдах боловч{" "}
            <span style={{ fontWeight: 600, color: "#000" }}>
              багцыг сэргээх боломжгүй
            </span>
            .
          </>
        }
        showModal={visible}
        setShowModal={setVisible}
        cancelHandler={() => setEditingId("")}
        submitHandler={() => handleDelete(editingId)}
      />

      <ConfirmModal
        showModal={featureModal}
        setShowModal={setFeatureModal}
        variant="warning"
        title="Итгэлтэй байна уу?"
        description={
          <>
            '<span style={{ fontWeight: 600, color: "#000" }}>Онцлох</span>'
            үйлдлийг хийснээр тухайн багц нь хэрэглэгчдэд{" "}
            <span style={{ fontWeight: 600, color: "#000" }}>Онцлох</span>{" "}
            хэсэгт харагдах бөгөөд ганцхан багц онцлох болохыг анхаарна уу!
          </>
        }
        cancelHandler={() => setToggleId(null)} // 🆕
        submitHandler={() => toggleId && handleFeature(toggleId)} // 🆕
      />
    </>
  );
}
